import { createAsyncThunk } from "@reduxjs/toolkit";

import paymentService from "../API/PaymentService";
import { OnlineOrderPayload, ProceedPaymentI, ProceedPaymentResponse, razorPayProcessI } from "../Interface/Payment.interface";


export const fetchPaymentData = createAsyncThunk<
  ProceedPaymentResponse,
  ProceedPaymentI,
  { rejectValue: string }
>("payment/fetchPaymentData", async (payload, thunkAPI) => {
  try {
    const response = await paymentService.ProceedPayment(payload);
    return response;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});

export const confirmPayment = createAsyncThunk<
  any,
  razorPayProcessI,
  { rejectValue: string }
>("payment/confirmPayment", async (payload, thunkAPI) => {
  try {
    const response = await paymentService.ConfirmPayment(payload);
    return response;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});


export const SavePayment = createAsyncThunk<
  any,
  OnlineOrderPayload,
  { rejectValue: string }>('payment/saveOrders',
    async (payload, thunkAPI) => {
      try {
        const response = await paymentService.SaveOrders(payload);
        return response
      }

      catch (error: any) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
      }

    })

